import { render } from "./ModalHistoricoPedidosMudanca.vue?vue&type=template&id=4c0f6ce2&scoped=true"
import script from "./ModalHistoricoPedidosMudanca.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoPedidosMudanca.vue?vue&type=script&lang=js"

import "./ModalHistoricoPedidosMudanca.vue?vue&type=style&index=0&id=4c0f6ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0f6ce2"]])

export default __exports__